import React, { useCallback } from 'react';
import classNames from 'classnames';
import { XIcon } from '../SvgIconsV3/X';
import { FilterPillContainer, PillLabel } from './FilterPill.styles';
import { createKeyClickHandler } from '../../util/handleKeys';

export type FilterPillProps = {
  value?: string;
  label?: string;
  handlePillClick?: () => void;
  labelMaxLength?: number;
  iconPosition?: 'left' | 'right';
  /**
   * @deprecated
   * Use className instead
   */
  customClass?: string;
} & React.HTMLAttributes<HTMLElement>;

const DEFAULT_MAX_LENGTH = 30;

export const FilterPill: React.FC<FilterPillProps> = ({
  value,
  label,
  children,
  handlePillClick,
  labelMaxLength = DEFAULT_MAX_LENGTH,
  iconPosition = 'left',
  customClass,
  className,
  ...rest
}) => {
  const handleClick = useCallback(() => {
    if (handlePillClick && typeof handlePillClick === 'function') {
      handlePillClick();
    }
  }, [handlePillClick]);

  const onKeyUp = useCallback((event) => createKeyClickHandler(handleClick)(event), [handleClick]);

  return (
    <FilterPillContainer
      className={classNames(customClass, className)}
      onClick={handleClick}
      iconPosition={iconPosition}
      data-value={value}
      role="button"
      tabIndex={0}
      onKeyUp={onKeyUp}
      {...rest}
    >
      <PillLabel>
        {children}
        {label && label.length > labelMaxLength
          ? `${label.substring(0, labelMaxLength - 1)}...`
          : label}
      </PillLabel>
      <XIcon />
    </FilterPillContainer>
  );
};

export default FilterPill;
